module.exports = __webpack_public_path__ + "img/template-dne-market-01.6e2052ae.jpg";